import { AxiosInstance } from 'axios';

import { imageEndpoints } from '../../utils/constants';
import { axios } from '../axiosInstance';

class ImagesApi {
  #requestInstance: AxiosInstance;

  constructor(axiosInstance: AxiosInstance) {
    this.#requestInstance = axiosInstance;
  }

  remove = async (id: string) => {
    return this.#requestInstance.delete(imageEndpoints.getImageById(id));
  };

  create = async (input: FormData) => {
    return this.#requestInstance.post(imageEndpoints.postImage, input);
  };

  createMany = async (input: FormData) => {
    return this.#requestInstance.post(imageEndpoints.postImages, input);
  };

  updatePreview = async (id: string) => {
    return this.#requestInstance.patch(imageEndpoints.previewImage(id));
  };
}

export const imagesApi = new ImagesApi(axios);
